module.exports = __webpack_public_path__ + "img/DE01032.2ec102a2.png";